import { useState } from "react";
import { ReactComponent as DeleteIcon } from "../../Icons/Delete.svg";
import{ReactComponent as ImportIcon} from "../../Icons/import-icon.svg";
import{ReactComponent as DownloadIcon} from "../../Icons/Download.svg";
import{ReactComponent as CopyIcon} from "../../Icons/Copy.svg";
import{ReactComponent as ExampleIcon} from "../../Icons/notepad.svg";
import{ReactComponent as RemoveIcon} from "../../Icons/x.svg"



export function InputHeaderButtons({
  primaryLabel,
  onPrimary,
  showImport = true,
  onImport,
  showClear = true,
  onClear,
  showExecute,
  onExecute,
  executeLabel,
  showRemove,
  onRemove,
  accept = ".json,.txt,.csv,.xml,.yaml,.yml",
})
{
 const handleImport = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = accept;

    input.onchange = (e) => {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      reader.onload = (event) => {
        const content = event.target.result;

        if (onImport) {
          onImport(content);
        }
      };

      reader.readAsText(file);
    };

    input.click();
  };

  return (
    <>
    <div className="header-buttons">
     {primaryLabel &&(
        <div className="HeaderButton" onClick={onPrimary} disabled={!onPrimary}>
          <ExampleIcon className="headerIcon"/>&nbsp;{primaryLabel}
        </div>
      )}
      {showImport && (
        <div className="HeaderButton" onClick={handleImport} disabled={!onImport}>
          <ImportIcon className="headerIcon" />&nbsp;Import
        </div>
      )}
      {showClear && (
        <div className="HeaderButton ClearButton" onClick={onClear} disabled={!onClear}>
          <DeleteIcon className="ClearButton" />&nbsp;Clear
        </div>
      )}
       {showRemove && <div className="HeaderButton" onClick={onRemove}>
        <RemoveIcon className="headerIcon"/>
        </div>}
      </div>
       {showExecute && (
        <button className="ExecuteButton" onClick={onExecute}>
          {executeLabel}
        </button>
      )}

    </>
  );
}

export function OutputHeaderButtons({
  outputText = "",
  fileName,
  mimeType = "text/plain;charset=utf-8",
  extraButton,
}) {
  const hasOutput = Boolean(outputText);

  const [hasDownloaded, setHasDownloaded] = useState(false);
  const [hasCopied, setHasCopied] = useState(false);

  const handleDownload = () => {
    if (!hasOutput) return;

    const blob = new Blob([outputText], { type: mimeType });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName || "output.txt";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);

    // âœ… show tooltip feedback
    setHasDownloaded(true);
    setTimeout(() => setHasDownloaded(false), 2000);
  };

  const handleCopy = async () => {
    if (!hasOutput) return;

    try {
      await navigator.clipboard.writeText(outputText);
    } catch {
      const textarea = document.createElement("textarea");
      textarea.value = outputText;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      textarea.remove();
    }

    setHasCopied(true);
    setTimeout(() => setHasCopied(false), 2000);
  };

  return (
    <>
      {extraButton}

      {/* Download */}
      <div
        className="HeaderButton OutputActionButton tooltip-wrapper"
        onClick={handleDownload}
      >
        <DownloadIcon/>&nbsp; {hasDownloaded ? "Downloaded" : "Download"}

       {hasDownloaded &&  <div className="tooltip-header">
             Downloaded
          </div>}
      
      </div>

      {/* Copy */}
      <div
        className="HeaderButton OutputActionButton tooltip-wrapper"
        onClick={handleCopy}
      >
        <CopyIcon/>&nbsp;Copy

        {hasCopied && (
          <div className="tooltip-header">
           Copied
          </div>
        )}
      </div>
    </>
  );
}


